import { useCallback } from 'react'

import { useLocalStorageKey } from '../../../utils/local-storage/useLocalStorageKey.hooks'

export const SIDEBAR_COLLAPSED_STORAGE_KEY = 'navV3.sidebarCollapsed'

/**
 * Persists the sidebar collapse/open state in localStorage so it sticks across
 * page loads. Defaults to open (expanded) when no preference has been saved —
 * the previous viewport-width-driven default has been dropped.
 */
export const useSidebarCollapsedPersistence = (): [boolean, (next: boolean) => void] => {
  const { data, setData } = useLocalStorageKey<{ collapsed: boolean }>(
    SIDEBAR_COLLAPSED_STORAGE_KEY
  )

  const isCollapsed = data?.collapsed ?? false

  const setCollapsed = useCallback(
    (next: boolean) => {
      setData({ collapsed: next })
    },
    [setData]
  )

  return [isCollapsed, setCollapsed]
}
